import http from './http'

import VueI18n, { messages } from '@/i18n'
import Vue from 'vue'

export const request = {}
const messagesConst = messages[VueI18n.locale]
const language = VueI18n.locale
let key = 'Cn'
// 判断中英文
if (language === 'zh-CN') {
    key = 'Cn'
} else {
    key = 'En'
}
let regex = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig

if (window.location.href.indexOf('124.93.26.118') > -1) {
    window.SITE_CONFIG['apiURL'] = 'http://124.93.26.118:8080'
    window.SITE_CONFIG['apiBaseURL'] = 'http://124.93.26.118:8080'
    window.SITE_CONFIG['actApiURL'] = 'http://124.93.26.118:8080/activiti'
    window.SITE_CONFIG['withoutPortURL'] = 'http://124.93.26.118'
}
let baseUrl = window.SITE_CONFIG['apiBaseURL']
const apiURL = window.SITE_CONFIG['actApiURL']

request.post = function (url, param, type) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    if (param) {
        this.param = param
        for (let item in param) {
            if (isString(param[item])) {
                param[item] = param[item].trim()
            }
            if (item.indexOf(key) < 0) {
                param[item + key] = param[item]
            }
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    this.core = http.post(this.url, this.param)
    return this
}

request.postNoTrim = function (url, param, type) {
    // this.url = baseUrl + '/admin' + url
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    if (param) {
        this.param = param
        for (let item in param) {
            param[item + key] = param[item]
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    this.core = http.post(this.url, this.param)
    return this
}
request.getDIY = function (url, param) {
    var params = {
    }
    // param.responseType = 'blob'
    params.params = param
    http.get(baseUrl + url, params).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                // window.navigator.msSaveBlob(blob, downloadFileName)
                window.navigator.msSaveBlob(blob)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                // a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
        }
    })
}
request.get = function (url, param, type) {
    // else if (url.indexOf('/sys/commuser/queryUserForRecruitmentByPage')>=0) {
    //     baseUrl = 'http://localhost:8001'
    // }
    // this.url = baseUrl + '/admin' + url
    // if (url.indexOf('/acdc/restrict')>=0) {
    //     baseUrl = 'http://localhost:8001'
    // } else {
    //     baseUrl = window.SITE_CONFIG['apiBaseURL']
    // }
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let params = {}
    var canSubmit = true
    if (param) {
        Object.keys(param).forEach(function (key) {
            if (param[key] instanceof Array) {
                if (param[key].length > 0) {
                    param[key] = param[key].join(',')
                }
            }
        })
        params.params = param
        for (let item in params.params) {
            if (params.params[item] instanceof Array) {
                delete params.params[item]
            } else {

                if (isString(params.params[item])) {
                    params.params[item] = params.params[item].trim()
                }
                if (item.indexOf(key) < 0) {
                    param[item + key] = param[item]
                }

            }
        }
    } else {
        params.params = {}
    }
    if (canSubmit) {
        params.params['language'] = key
        this.core = http.get(this.url, params)
        return this
    }
}
request.put = function (url, param, type) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    if (param) {
        this.param = param
        for (let item in param) {
            if (item.indexOf(key) > -1) {
                break
            }
            param[item + key] = param[item]
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    this.core = http.put(this.url, this.param)
    return this
}
request.delete = function (url, param, type) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let params = {}
    if (param) {
        params.params = param
        for (let item in params.params) {
            if (params.params[item] instanceof Array) {
                delete params.params[item]
            } else {
                if (isString(params.params[item])) {
                    params.params[item] = params.params[item].trim()
                }
                if (item.indexOf(key) < 0) {
                    param[item + key] = param[item]
                }
            }
        }
    } else {
        params.params = {}
    }
    params.params['language'] = key
    this.core = http.delete(this.url, params)
    return this
}
request.then = function (func) {
    this.core.then(data => {
        data.total = 0
        if (data.data && data.data.records) {
            let records = data.data.records
            data.total = data.data.total
            data['result'] = records
            // data.data = records
        } else {
            data['result'] = data.data
            // 如果没有使用结构体进行返回, 为了能让mixins的getDataList解析，对返回的结构体赋值records
            if (data.data instanceof Object) {
                // data.data['records'] = data.data
            }
        }
        func(data.data, data.total, data.code, data)
    })
    return this
}
request.thenSingle = function (func) {
    this.core.then(data => {
        func(data)
    })
    return this
}
request.catch = function (func) {
    this.core.catch(data => {
        func(data)
    })
    return this
}
request.finally = function (func) {
    this.core.finally(func)
}
request.download = function (url, fileName, params, type, email) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })

        for (let item in params) {
            if (isString(params[item])) {
                params[item] = params[item].trim()
            }
            if (item.indexOf(key) < 0) {
                params[item + key] = params[item]
            }
        }

        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param.params['language'] = key

    http.get(this.url, param).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
        }
    })
}


request.loadingDownload = function (url, fileName, params, type, email) {
   return new Promise((resolve, reject) => {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })

        for (let item in params) {
            if (isString(params[item])) {
                params[item] = params[item].trim()
            }
            if (item.indexOf(key) < 0) {
                params[item + key] = params[item]
            }
        }

        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param.params['language'] = key

    http.get(this.url, param).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
            resolve(false)
        }
    })
})
}

request.loadingDownload = function (url, fileName, params, type, email) {
   return new Promise((resolve, reject) => {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })

        for (let item in params) {
            if (isString(params[item])) {
                params[item] = params[item].trim()
            }
            if (item.indexOf(key) < 0) {
                params[item + key] = params[item]
            }
        }

        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param.params['language'] = key

    http.get(this.url, param).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
            resolve(false)
        }
    })
})
}
// Activity的download方法
request.downloadActivity = function (url, fileName, params, type, email) {
    this.url = apiURL + url
    if (type && type.length > 0) {
        this.url = apiURL + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
        }
    })
}
// 下载文件通过Post方法
request.downloadByPost = function (url, fileName, param, type, email) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    if (param) {
        this.param = param
        for (let item in param) {
            if (isString(param[item])) {
                param[item] = param[item].trim()
            }
            if (item.indexOf(key) < 0) {
                param[item + key] = param[item]
            }
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    let downloadFileName = 'download.xls' && fileName + '.xls'
    let configTest = {}
    configTest.responseType = 'blob'
    return http.post(this.url, param, configTest)
}
// 下载xls文件通过Post方法并下载
request.downloadByPost7=function (url, fileName, param, type, email) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    if (param) {
        this.param = param
        for (let item in param) {
            if (isString(param[item])) {
                param[item] = param[item].trim()
            }
            if (item.indexOf(key) < 0) {
                param[item + key] = param[item]
            }
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    let configTest = {}
    configTest.responseType = 'blob'
    return http.post(this.url, param, configTest).then((data) => {
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
        }
    })
}

// 下载文件通过Post方法
request.downloadByPost2 = function (url, fileName, params) {
    // if (url.indexOf('/acdc/acdcCommon/download') >=0) {
    //     baseUrl = 'http://localhost:8001'
    // }
    this.url = baseUrl + url
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.pdf' && fileName + '.pdf'
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        let reader = new FileReader()
        let blob = new Blob([data], {type: 'application/vnd.ms-excel;charset=utf8'})
        if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
            window.navigator.msSaveBlob(blob,downloadFileName)
        } else {
            let down = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            down.href = href
            down.download = downloadFileName
            document.body.appendChild(down)
            down.click()
            document.body.removeChild(down)
            window.URL.revokeObjectURL(href)
        }
    })
}

// 下载pdf
request.downloadPDF = function (url, fileName, params, type) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        param.params = params
    }
    let downloadFileName = 'download.pdf' && fileName + '.pdf'
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        if (data.size === 0) {
            Vue.prototype.$alert('下载失败', messagesConst.prompt.title).then((res) => {
                console.log(res)
            }).catch((err) => {
                console.log(err)
            })
            return false
        }
        var reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
            var blob = convertBase64UrlToBlob(e.target.result)
            if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
                window.navigator.msSaveBlob(blob, downloadFileName)
            } else {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a')
                a.download = downloadFileName
                a.href = e.target.result
                document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
                a.click()
                document.getElementsByTagName('body')[0].removeChild(a)
            }
        }
    })
}

request.postAct = function (url, param) {
    this.url = apiURL + url
    if (param) {
        this.param = param
        for (let item in param) {
            if (item.indexOf(key) > -1) {
                break
            }
            if (isString(param[item])) {
                param[item] = param[item].trim()
                /*  if (param[item] != null && param[item].match(regex)) {
                    param[item] = ''
                    Vue.prototype.$alert('不允许输入表情等特殊字符', messagesConst.prompt.title).then(() => {
                    }).catch(() => { })
                    return new Promise((resolve, reject) => {
                      reject()
                    })
                  }*/
            }
            param[item + key] = param[item]
        }
    } else {
        this.param = {}
    }
    this.param['language'] = key
    this.core = http.post(this.url, this.param)
    return this
}
request.getAct = function (url, param) {
    this.url = apiURL + url
    let params = {}
    if (param) {
        params.params = param
        for (let item in params.params) {
            if (params.params[item] instanceof Array) {
                delete params.params[item]
            } else {
                if (isString(params.params[item])) {
                    params.params[item] = params.params[item].trim()
                    /*if (params.params[item] != null && params.params[item].match(regex)) {
                      params.params[item] = ''
                      Vue.prototype.$alert('不允许输入表情等特殊字符', messagesConst.prompt.title).then(() => {
                      }).catch(() => { })
                      return new Promise((resolve, reject) => {
                        reject()
                      })
                    }*/
                }
                if (item.indexOf(key) < 0) {
                    param[item + key] = param[item]
                }
            }
        }
    } else {
        params.params = {}
    }
    params.params['language'] = key
    this.core = http.get(this.url, params)
    return this
}
request.deleteAct = function (url, param, type) {
    this.url = apiURL + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let params = {}
    if (param) {
        params.params = param
        for (let item in params.params) {
            if (params.params[item] instanceof Array) {
                delete params.params[item]
            } else {
                if (isString(params.params[item])) {
                    params.params[item] = params.params[item].trim()
                    /*if (params.params[item] != null && params.params[item].match(regex)) {
                      params.params[item] = ''
                      Vue.prototype.$alert('不允许输入表情等特殊字符', messagesConst.prompt.title).then(() => {
                      }).catch(() => { })
                      return new Promise((resolve, reject) => {
                        reject()
                      })
                    }*/
                }
                if (item.indexOf(key) < 0) {
                    param[item + key] = param[item]
                }
            }
        }
    } else {
        params.params = {}
    }
    params.params['language'] = key
    this.core = http.delete(this.url, params)
    return this
}

export default request

/**
 * 将 base64 转换位 blob 对象
 * blob 存储 2进制对象的容器
 * @export
 * @param {*} base64
 * @returns
 */
function convertBase64UrlToBlob(base64) {
    var parts = base64.split(';base64,')
    var contentType = parts[0].split(':')[1]
    var raw = window.atob(parts[1])
    var rawLength = raw.length
    var uInt8Array = new Uint8Array(rawLength)
    for (var i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: contentType })
}

// 判断浏览器类型
function myBrowser() {
    var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    if (userAgent.indexOf('OPR') > -1) {
        return 'Opera'
    }; // 判断是否Opera浏览器 OPR/43.0.2442.991
    if (userAgent.indexOf('Firefox') > -1) {
        return 'FF'
    } // 判断是否Firefox浏览器 Firefox/51.0
    if (userAgent.indexOf('Trident') > -1) {
        return 'IE'
    } // 判断是否IE浏览器  Trident/7.0; rv:11.0
    if (userAgent.indexOf('Edge') > -1) {
        return 'Edge'
    } // 判断是否Edge浏览器  Edge/14.14393
    if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome'
    } // Chrome/56.0.2924.87
    if (userAgent.indexOf('Safari') > -1) {
        return 'Safari'
    } // 判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
}
function isString(obj) {
    return obj === obj + ''
}
function removeEmoji(str) {
    if (str.match(regex)) {
        return ''
    } else {
        return str
    }
}
request.downloadLearning = function (url, fileName, params, type, email) {
    console.log('downloadLearning')
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        console.log('http.get')
        console.log(data)
        let reader = new FileReader()
        let blob = new Blob([data], {type: 'application/vnd.ms-excel;charset=utf8'})
        if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
            window.navigator.msSaveBlob(blob,downloadFileName)
        } else {
            let down = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            down.href = href
            down.download = downloadFileName
            document.body.appendChild(down)
            down.click()
            document.body.removeChild(down)
            window.URL.revokeObjectURL(href)
        }
    })
}
request.downloadITM = function (url, fileName, params, type, email) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.xlsx' && fileName + '.xlsx'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        console.log('http.get')
        console.log(data)
        let reader = new FileReader()
        let blob = new Blob([data], {type: 'application/vnd.ms-excel;charset=utf8'})
        if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
            window.navigator.msSaveBlob(blob,downloadFileName)
        } else {
            let down = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            down.href = href
            down.download = downloadFileName
            document.body.appendChild(down)
            down.click()
            document.body.removeChild(down)
            window.URL.revokeObjectURL(href)
        }
    })
}
request.downloadRm = function (url, fileName, params, type, email) {
    console.log('downloadRm')
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.xls' && fileName + '.xls'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        console.log('http.get')
        console.log(data)
        let reader = new FileReader()
        let blob = new Blob([data], {type: 'application/vnd.ms-excel;charset=utf8'})
        if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
            window.navigator.msSaveBlob(blob,downloadFileName)
        } else {
            let down = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            down.href = href
            down.download = downloadFileName
            document.body.appendChild(down)
            down.click()
            document.body.removeChild(down)
            window.URL.revokeObjectURL(href)
        }
    })
}
request.calendarDownload = function (url, fileName, params, type, email) {
    console.log('calendarDownload')
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        Object.keys(params).forEach(function (key) {
            if (params[key] instanceof Array) {
                if (params[key].length > 0) {
                    params[key] = params[key].join(',')
                }
            }
        })
        param.params = params
    }
    let downloadFileName = 'download.xlsx' && fileName + '.xlsx'
    if (email) {
        downloadFileName = fileName
    }
    param.responseType = 'blob'
    param['language'] = key
    http.get(this.url, param).then((data) => {
        console.log('http.get')
        console.log(data)
        let reader = new FileReader()
        let blob = new Blob([data], {type: 'application/vnd.ms-excel;charset=utf8'})
        if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
            window.navigator.msSaveBlob(blob,downloadFileName)
        } else {
            let down = document.createElement('a')
            let href = window.URL.createObjectURL(blob)
            down.href = href
            down.download = downloadFileName
            document.body.appendChild(down)
            down.click()
            document.body.removeChild(down)
            window.URL.revokeObjectURL(href)
        }
    })
}
request.getlearningS = function (url, param, type) {
    //this.url = updateURL(url)
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let params = {}
    if (param) {
        Object.keys(param).forEach(function (key) {
            if (param[key] instanceof Array) {
                if (param[key].length > 0) {
                    param[key] = param[key].join(',')
                }
            }
        })
        params.params = param
        for (let item in params.params) {
            if (params.params[item] instanceof Array) {
                delete params.params[item]
            } else {
                if (item.indexOf(key) < 0) {
                    param[item + key] = param[item]
                }
                if (isString(params.params[item])) {
                    params.params[item] = params.params[item].trim()
                }
            }
        }
    } else {
        params.params = {}
    }
    params.params['language'] = key
    this.params=params
    //this.core = http.get(this.url, params)
    return this
}

request.downloadBigFile = function (url, fileName, params, type) {
    this.url = baseUrl + url
    if (type && type.length > 0) {
        this.url = baseUrl + type + url
    }
    let param = {}
    if (params === undefined || params === null) {
        param['params'] = {}
    } else {
        param.params = params
    }
    let downloadFileName = fileName
    if (!downloadFileName) {
        downloadFileName = 'download.xls'
    }
    param.responseType = 'blob'
    param['language'] = 'Cn'  /// key
    http.get(this.url, param).then((data) => {
        if (data.size === 0) {
        Vue.prototype.$alert('下载失败', messagesConst.prompt.title).then((res) => {
            console.log(res)
        }).catch((err) => {
            console.log(err)
        })
        return false
    }
    let blob = new Blob([data], {type: getDownLoadType(downloadFileName)})

    if (myBrowser() === 'IE' || myBrowser() === 'Edge') {
        window.navigator.msSaveBlob(blob,downloadFileName)
    } else {
        let down = document.createElement('a')
        let href = window.URL.createObjectURL(blob)
        down.href = href
        down.download = downloadFileName
        document.body.appendChild(down)
        down.click()
        document.body.removeChild(down)
        window.URL.revokeObjectURL(href)
    }
})
}
function getDownLoadType(fileName) {
    if(!fileName) {
        return 'application/vnd.ms-excel;charset=utf8'
    } else {
        let type = ''
        let fullName = fileName
        let idx = fullName.lastIndexOf(".")
        let extName = fullName.substr(idx + 1);
        extName = extName.toUpperCase()
        if (extName === 'DOC') {
            type = 'application/msword'
        } else if (extName === 'DOCX') {
            type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        } else if (extName === 'XLS') {
            type = 'application/vnd.ms-excel'
        } else if (extName === 'XLSX') {
            type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        } else if (extName === 'TXT') {
            type = 'text/plain'
        } else if ((extName === 'JPG') || (extName === 'JPEG') || (extName === 'PNG') || (extName === 'BMP')) {
            type = 'application/octet-stream'
        } else if (extName === 'PDF') {
            type = 'application/octet-stream'
        }
        return type
    }
}
